import React, { useState } from 'react';
import Toast from './Toast';

export default function Capabilities() {
  const [toast, setToast] = useState(null);

  const showToast = (msg) => {
    setToast({ message: msg, type: 'default' });
    setTimeout(() => setToast(null), 3000);
  };

  return (
    <div className="admin-page">
      <div className="admin-page__head">
        <div>
          <h1 className="admin-page__title">Capabilities <em>· ordered list</em></h1>
          <div className="admin-page__sub">
            <span><strong>9</strong> capabilities</span>
            <span>Order reflects /capabilities page</span>
          </div>
        </div>
        <div className="admin-page__actions">
          <button className="btn-ghost" onClick={() => showToast('Preview opened')}>Preview ↗</button>
          <button className="btn-primary" onClick={() => showToast('New capability created')}>+ New capability</button>
        </div>
      </div>

      <div style={{ marginTop: '32px' }}>
        {['/01', '/02', '/03'].map((num, idx) => (
          <div key={idx} style={{ display: 'grid', gridTemplateColumns: '40px 40px 1fr 200px 80px 80px 40px', gap: '12px', alignItems: 'center', padding: '16px', borderBottom: '1px solid rgba(244,241,234,0.08)', cursor: 'grab' }}>
            <span style={{ fontSize: '14px', color: 'var(--graphite-2)', textAlign: 'center' }}>⋮⋮</span>
            <span style={{ fontFamily: 'Geist Mono', fontSize: '11px', color: 'var(--graphite-2)' }}>{num}</span>
            <div>
              <strong style={{ display: 'block' }}>Capability Name</strong>
              <span style={{ fontSize: '12px', color: 'var(--graphite-2)' }}>Short description of the capability and what it means</span>
            </div>
            <span style={{ fontSize: '12px', color: 'var(--graphite-2)' }}>Used by 4 projects</span>
            <span style={{ fontSize: '10px', padding: '2px 6px', backgroundColor: 'rgba(111,207,151,0.2)', color: '#6FCF97', borderRadius: '2px' }}>Public</span>
            <button className="btn-ghost" style={{ padding: '6px 12px', fontSize: '12px' }}>edit</button>
            <button onClick={() => showToast('Delete confirm')} style={{ background: 'none', border: 'none', color: 'var(--graphite-2)', cursor: 'pointer', fontSize: '14px' }}>⋯</button>
          </div>
        ))}
      </div>

      {toast && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
}
